"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const Arrow_1 = require("components/styled/Arrow");
const Colors_1 = require("components/styled/Colors");
const Containers_1 = require("components/styled/Containers");
const Grid_1 = require("components/styled/Grid");
const Rocket_1 = require("components/styled/img/Rocket");
const RocketMobile_1 = require("components/styled/img/RocketMobile");
const Text_1 = require("components/styled/Text");
const Navbar_1 = require("components/styled/Navbar");
exports.Hero = ({ title, content }) => (React.createElement(Containers_1.HeroContainer, null,
    React.createElement(Navbar_1.Navbar, null),
    React.createElement(Containers_1.HeroContent, null,
        React.createElement(Grid_1.Row, null,
            React.createElement(Grid_1.Column, { width: 4, widthTablet: 3 },
                React.createElement(Rocket_1.Rocket, null)),
            React.createElement(Grid_1.Column, { width: 8, widthTablet: 5 },
                React.createElement(RocketMobile_1.RocketMobile, null),
                React.createElement(Text_1.HeroTitle, null, title),
                React.createElement(Text_1.HeroText, null, content))),
        React.createElement(Arrow_1.ArrowLink, { color: Colors_1.KARL, target: "1" }))));



// WEBPACK FOOTER //
// ./src/components/sections/Hero.tsx